export default function SalaryIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="18"
      viewBox="0 0 20 18"
      fill="none"
    >
      <path
        d="M2.62495 10.4318V1.875C2.62495 1.67609 2.70397 1.48532 2.84462 1.34467C2.98528 1.20402 3.17604 1.125 3.37495 1.125H17.625C17.8239 1.125 18.0146 1.20402 18.1553 1.34467C18.2959 1.48532 18.375 1.67609 18.375 1.875V16.125C18.375 16.3239 18.2959 16.5147 18.1553 16.6553C18.0146 16.796 17.8239 16.875 17.625 16.875H11.2158M10.5 11.25L4.5 17.25L1.5 14.25"
        stroke="#B18A00"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
